import { Chart } from "react-chartjs-2";

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Filler,
} from 'chart.js';
import { useEffect, useMemo } from "react";
import { ChargingData } from "../../data/models/ChargingData";
import { planEV } from "../../assets/profile-steering/ProfileSteering";
import useProfileData from "../../hooks/useProfileData";
import useUserData from "../../hooks/useUserData";
import { ChargingMode } from "../../data/models/ChargingMode";
import { getCookie } from "../../data/Cookies";

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Filler,
    Legend,
    Tooltip,
    LineController,
    BarController
);

interface ProgressGraphProps {
    planning: {name: string, charge: number} []
}

export default function ProgressGraph({planning}: ProgressGraphProps) {
  
    let data = planning.filter(x => x.charge > 0)
    const graphData = {
        datasets: [
            {
                label: 'Energy',
                borderColor: '#77c768',
                pointRadius: 0,
                data: data.map(
                    i => {
                        return {
                            x: i.name,
                            y: i.charge
                        }
                    }
                )
            }
        ]
    }

    const options = {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                ticks: {
                    callback: function (value, index, ticks) {
                        return Math.round(value/100)/10 + " kW";
                    }
                }
            }
        },
        plugins: {
            legend: {
                display: false
            }
        }
    }


    return (
        <Chart type='line' data={graphData} options={options}/>
    )
}